/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type ProcessCodes = typeof ProcessCodes[keyof typeof ProcessCodes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessCodes = {
  SIGN_ON: 'SIGN_ON',
  SELF_REGISTRATION_DEPOSIT: 'SELF_REGISTRATION_DEPOSIT',
  PUSH_REQUEST_CONFIRMED: 'PUSH_REQUEST_CONFIRMED',
  LOAN_ELIGIBILITY_REQUEST: 'LOAN_ELIGIBILITY_REQUEST',
  LOAN_ELIGIBILITY_RESPONSE: 'LOAN_ELIGIBILITY_RESPONSE',
  LOAN_APPLICATION_REQUEST: 'LOAN_APPLICATION_REQUEST',
  AMOUNT_DEPOSIT: 'AMOUNT_DEPOSIT',
  LOAN_REPAYMENT: 'LOAN_REPAYMENT',
  WHATSAPP_NOTIFICATION_REQUEST: 'WHATSAPP_NOTIFICATION_REQUEST',
  ACCOUNT_STATEMENT_REQUEST: 'ACCOUNT_STATEMENT_REQUEST',
} as const;
